---
title: "How to calculate the difference between two dates without a spreadsheet"
description: "A practical date-difference flow for deadlines, vacations and periods: days, weeks, approximate months and business days."
locale: "en"
date: "2026-06-23"
tags: ["date difference", "date calculator", "local"]
relatedTools: ["date-difference"]
translations:
  ru: "kak-poschitat-raznicu-mezhdu-datami"
faq:
  - q: "Are the selected dates uploaded?"
    a: "No. The calculator runs in your browser and does not send the selected dates to a server."
  - q: "Why are months and years approximate?"
    a: "Months have different lengths, so dateify shows a quick estimate based on the number of days."
---

The difference between two dates sounds obvious until you need to decide
whether the last day counts, whether weekends should be excluded, and how
to explain a period that crosses several months. A spreadsheet can do it,
but a one-off check is faster in a dedicated calculator.

Open the [date difference calculator](/raznica-mezhdu-datami), choose the
start and end dates, then enable the options you need. dateify shows days,
weeks, approximate months and years immediately. If the end date should be
included, turn on "Include end date".

## Where this helps

Common use cases include vacations, deadlines, document validity periods,
study periods, contracts and project plans. In those tasks, the raw day
count is only part of the answer: it is often easier to reason in weeks,
months or business days.

The business-days option counts Monday through Friday and excludes Saturday
and Sunday. Public holidays are not removed, so for HR or legal workflows
you should treat the result as a quick estimate rather than a formal
calculation.

## Why local calculation is cleaner

Dates rarely look sensitive on their own, but in work contexts they can be
tied to a contract, vacation, sick leave or internal deadline. dateify does
not upload the selected dates. The calculation happens inside the browser
tab, and the Network tab is enough to verify that behavior.
